export default __webpack_public_path__ + "static/media/glitch34.595cf354.png";